import { Component, forwardRef, OnChanges, KeyValueDiffers, ChangeDetectorRef, Inject, ElementRef, DOCUMENT } from '@angular/core';
import { BlockComponent } from '../../../../Common/PageBuilder/components/Block/block.component';
import { CuratedMentionListDisplayElementModel } from '../../models/curated-mention-list-display-element.model';
import { messageSeverityEnum } from '../../../../Common/Misc/enums/message-severity.enum';
import { AbstractPageBuilderService } from '../../../../Common/PageBuilder/services/abstract-page-builder.service';
import { BriefingsService } from '../../services/briefings.service';

import { ClickOutsideService } from '../../../../Common/PageBuilder/services/click-outside.service';
import { ButtonTypesEnum } from '../../../../Common/Forms/enums/button-types.enum';

@Component({
    selector: 'agpr-curated-mention-list-block',
    templateUrl: './curated-mention-list-block.component.html',
    styleUrls: ['./curated-mention-list-block.component.scss'],
    providers: [
        {
            provide: BlockComponent,
            useExisting: forwardRef(() => CuratedMentionListBlockComponent)
        }
    ],
    standalone: false
})
export class CuratedMentionListBlockComponent extends BlockComponent implements OnChanges {
    public readonly messageSeverityEnum = messageSeverityEnum;
    public readonly buttonTypes = ButtonTypesEnum;
    displayElement: CuratedMentionListDisplayElementModel;

    constructor(
        public differs: KeyValueDiffers,
        // This is actually briefingService, but injecting briefing service causes a circular dependency
        public briefingService: AbstractPageBuilderService,
        protected changeDetectorRef: ChangeDetectorRef,
        public clickOutsideService: ClickOutsideService,
        public el: ElementRef,
        @Inject(DOCUMENT) private document: Document
    ) {
        super(differs, briefingService, changeDetectorRef, clickOutsideService, el);
    }

    ngOnChanges(): void {
        super.ngOnChanges();
        this.displayElement = this.block.displayElement as CuratedMentionListDisplayElementModel;
    }

    /**
     * Shows the import tool dialog
     */
    showImportTool(): void {
        (this.briefingService as BriefingsService).openImportDialog(this.block);
    }

    onRendered(): void {
        // back to top link is used for email and web browser view
        // here we disabled it in briefing module.
        const shadowContainer = this.document.querySelector('#curated-mention-list-twig #agpr-twigRenderer');
        if (shadowContainer) {
            const backToTopLink = shadowContainer.shadowRoot.getElementById('backToTopLink');
            if (backToTopLink) {
                backToTopLink.onclick = function() {
                    return false;
                };
                backToTopLink.style.cursor = 'all-scroll';
            }

        }
    }
}
